<template lang="pug">
.image-modal
  b-modal(v-model="_value" :size="size" @ok="ok" no-close-on-backdrop no-close-on-esc hide-footer)
    template(#modal-header="{ ok }")
      .option-target-family-list-modal-header
        .d-flex.justify-content-start.align-items-center
          .d-flex.justify-content-end.flex-fill
            button.btn(@click="onDownload" type="button") ダウンロード
      button.close(type="button" @click="ok") ×

    .default-modal-body(v-if="_value").text-center
      img.image(:src="url")
</template>

<script lang="ts">
import { HitomeqErrorType } from "@/commons/models/SystemError";
import CommonService from "@/commons/services/CommonService";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 画像プレビューモーダル
 */
@Component
export default class ImageDownloadModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルサイズ */
  @Prop({ default: () => "xl" })
  size!: string;
  /** 表示する画像のURL。S3格納の場合は先に公開URLにしておく必要がある */
  @Prop()
  url!: string;
  /**  */
  @Prop()
  fileName!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### 画像ダウンロードする
   */
  public onDownload(): void {
    this.downloadImage(this.url, this.fileName);
    return;
  }

  /**
   * ### 画像ファイルをダウンロードさせる
   *
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public async downloadImage(url: string, fileName: string): Promise<void> {
    // 公開URLは認証情報として、ファイルパス＋クエリパラメータで構成されている
    // 「?」より前がリクエストURL、「?」より後がクエリパラメータ
    const splitedUrl: string[] = url.split("?");
    // クエリパラメータが複数の場合は「&」で区切られているので分割する
    const sourceParams: string[] = splitedUrl[1].split("&");
    const params: any = {};
    for (const param of sourceParams) {
      // クエリパラメータは「=」区切りでkeyとvalueで分かれているので分割してクエリパラメータに整形する
      const splitedParam: string[] = param.split("=");
      params[`${splitedParam[0]}`] = splitedParam[1];
    }
    // 画像だがblobとしてリクエストすればblobデータとして取得出来るのでそれをCSVダウンロードのようにa要素を作ってダウンロードさせる
    const commonService: CommonService = new CommonService();
    const response = await commonService.executeSimpleGet<Blob>(url, "className", params, HitomeqErrorType.SYSTEM_ERROR, "blob");

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(response.data);
    link.download = fileName;
    link.click();

    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>

<style lang="scss" scoped>
.image {
  max-width: 100%;
  max-height: 83vh;
}
</style>
